"use client";

import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { coreFeatures as data } from "@/lib/data/capabilities-narrative-engineering";

const accents = [
  "var(--color-crimson)",
  "var(--color-purple)",
  "var(--color-cyan)",
  "var(--color-emerald)",
  "var(--color-amber)",
  "var(--color-denim)",
  "var(--color-violet)",
  "var(--color-rose)",
] as const;

export function CoreFeatures() {
  return (
    <Section id="core-features" className="relative">
      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-denim)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
          </div>
        </Reveal>

        <div className="mt-12 grid sm:grid-cols-2 gap-5">
          {data.features.map((f, i) => {
            const accent = accents[i % accents.length]!;
            return (
              <Reveal key={f.number} delay={i * 60}>
                <div
                  className="glass rounded-2xl p-6 h-full"
                  style={{
                    boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 12%, transparent)`,
                  }}
                >
                  <div className="flex items-center gap-3 mb-3">
                    <span
                      className="grid place-items-center h-8 w-8 rounded-lg text-[11px] font-bold"
                      style={{
                        background: `color-mix(in oklch, ${accent} 18%, transparent)`,
                        color: accent,
                        boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 35%, transparent)`,
                      }}
                    >
                      {f.number}
                    </span>
                    <span className="eyebrow-tiny font-bold" style={{ color: accent }}>
                      Feature
                    </span>
                  </div>
                  <h3 className="text-base">{f.title}</h3>
                  <p className="mt-3 text-xs text-[rgb(var(--fg-muted))] leading-relaxed">{f.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </Container>
    </Section>
  );
}
